exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2fSwk{position:relative;background-color:#fff;border-bottom:1px solid #e0e0e0;padding:10px 15px}._2fSwk a:not([href]){color:inherit}._2ueP9{margin:0;position:relative;font-size:24px;color:#000;font-weight:400}", ""]);

// exports
exports.locals = {
	"root": "_2fSwk",
	"h1": "_2ueP9"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/PageTitle/PageTitle.css
// module id = 1972
// module chunks = 0 1 20 22